// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import FastTimer14 from './FastTimer14.tsx';
import FastTimer20 from './FastTimer20.tsx';
import FastTimer20Filled from './FastTimer20Filled.tsx';
import FastTimer20CircleFilled from './FastTimer20CircleFilled.tsx';
import FastTimer24 from './FastTimer24.tsx';
import FastTimer24Filled from './FastTimer24Filled.tsx';
import FastTimer24CircleFilled from './FastTimer24CircleFilled.tsx';
import FastTimer40 from './FastTimer40.tsx';
import FastTimer40Filled from './FastTimer40Filled.tsx';
import FastTimer48 from './FastTimer48.tsx';
import FastTimer48Filled from './FastTimer48Filled.tsx';

type FastTimerProps = {
    variation:
        | '14'
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    FastTimer14,
    FastTimer20,
    FastTimer20Filled,
    FastTimer20CircleFilled,
    FastTimer24,
    FastTimer24Filled,
    FastTimer24CircleFilled,
    FastTimer40,
    FastTimer40Filled,
    FastTimer48,
    FastTimer48Filled,
};

const FastTimer: FC<FastTimerProps> = ({ variation, ...props }) => {
    const variationKey = `FastTimer${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"FastTimer" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default FastTimer;
